import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { Box, Chip, Collapse, useTheme } from "@mui/material";
import React from "react";

import theme from "@/theme/theme.tsx";
import { lowerCaseToCapCase } from "@/utils";

export default React.memo(function SelectNonGroups({
  index,
  data,
  activeChannels,
  toggleAllGroupFeeds,
  toggleSingleFeed,
  openGroups,
  toggleOpenGroup,
  containerClassList,
}: {
  index: number;
  data: any[];
  activeChannels: string[];
  toggleAllGroupFeeds: (ids: string[]) => void;
  toggleSingleFeed: (id: string) => void;
  openGroups: string[];
  toggleOpenGroup: (groupId: string) => void;
  containerClassList: { active: object; inactive: object };
}) {
  const theme = useTheme();
  const activeContainerClass = data?.some((feed) => activeChannels.includes(feed.id))
    ? containerClassList.active
    : containerClassList.inactive;
  return (
    <Box sx={{ ...activeContainerClass }} key={`select-non-groups-${index}`}>
      {data?.length > 0 && (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                cursor: "pointer",
                alignItems: "center",
                gap: 1,
              }}
              onClick={() => toggleOpenGroup("non-grouped-feeds")}
            >
              <Box sx={{ display: "flex" }}>
                {openGroups.includes("non-grouped-feeds") ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
              </Box>
              <Box sx={{ fontWeight: "bold", display: "flex" }}>Non Grouped Feeds ({data.length})</Box>
            </Box>
          </Box>

          <Collapse in={openGroups.includes("non-grouped-feeds")}>
            <Box sx={{ mt: 1, p: 1 }}>
              {data?.length > 1 && (
                <Box onClick={() => toggleAllGroupFeeds(data.map((feed) => feed.id))} sx={{ display: "flex", gap: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      gap: 1,
                      ml: 0.5,
                      mb: 1,
                    }}
                  >
                    {activeChannels.some((feedId) => data.map((feed) => feed.id).includes(feedId)) ? (
                      <>
                        <Box sx={{ display: "flex" }}>
                          <CheckBoxIcon sx={{ color: theme.palette.info.main }} />
                        </Box>
                        <Box>De-Select All</Box>
                      </>
                    ) : (
                      <>
                        <Box sx={{ display: "flex" }}>
                          <CheckBoxOutlineBlankIcon
                            sx={{
                              color: theme.palette.brand.other.gray.main,
                            }}
                          />
                        </Box>
                        <Box>Select All</Box>
                      </>
                    )}
                  </Box>
                </Box>
              )}
              {data?.map((ngFeed) => (
                <div key={ngFeed.id}>
                  <button
                    className="basic-button"
                    key={ngFeed.id}
                    style={{
                      width: "100%",
                      marginBottom: 1,
                    }}
                    onClick={() => toggleSingleFeed(ngFeed.id)}
                  >
                    {activeChannels?.includes(ngFeed.id) ? (
                      <CheckBoxIcon sx={{ color: theme.palette.info.main }} />
                    ) : (
                      <CheckBoxOutlineBlankIcon sx={{ color: theme.palette.brand.other.gray.main }} />
                    )}
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        gap: 1,
                      }}
                    >
                      <Box
                        sx={{
                          pt: ngFeed?.commandAlias?.length ? 2 : 0,
                        }}
                      >
                        <Box
                          sx={{
                            flexGrow: 1,
                            textAlign: "left",
                          }}
                        >
                          {ngFeed.title}
                        </Box>

                        {ngFeed?.commandAlias?.length > 0 && (
                          <Box
                            sx={{
                              display: "flex",
                              fontSize: "10px",
                              gap: 1,
                            }}
                          >
                            {ngFeed?.commandAlias.map((alias) => (
                              <Chip
                                key={alias.id}
                                label={lowerCaseToCapCase(alias.alias)}
                                size="small"
                                sx={{
                                  py: 0.15,
                                  width: "auto",
                                  height: "auto",
                                  background: theme.palette.info.main,
                                }}
                              />
                            ))}
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </button>
                </div>
              ))}
            </Box>
          </Collapse>
        </>
      )}
    </Box>
  );
});
